import React, { forwardRef, useRef, useEffect } from 'react'
import { Radio } from '@ow/comps'

const RadioBox = forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = useRef()
  const resolvedRef = ref || defaultRef

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate
  }, [resolvedRef, indeterminate])

  return <Radio name="radio" ref={resolvedRef} {...rest} />
})
export default RadioBox
